import React from "react";
import QRCode from "react-qr-code";
import { useTranslation } from "lib/i18n/use-translation";
import styles from "./styles.module.scss";
import phonesImage from "Assets/images/signpost-phones.webp";

const BRANCH_DOWNLOAD_LINK =
  process.env.REACT_APP_ENV === "prod"
    ? "https://wone.app/Gr7VmXUky1b"
    : "https://walkingonearth.test-app.link/DDCQXWAky1b";

export const MobileAppSignpostCard = () => {
  const { t } = useTranslation(["components"]);

  return (
    <div className={styles["card-container"]}>
      <div className={styles["content-section"]}>
        <div className={styles["text-content"]}>
          <h3 className={styles["card-title"]}>
            {t("components:mobileAppSignpost.title")}
          </h3>
          <p className={styles["card-description"]}>
            {t("components:mobileAppSignpost.description")}
          </p>
        </div>
        <div className={styles["qr-wrapper"]}>
          <QRCode value={BRANCH_DOWNLOAD_LINK} size={62} />
        </div>
      </div>
      <div className={styles["image-section"]}>
        <img
          className={styles["phones-image"]}
          src={phonesImage}
          alt={t("components:mobileAppSignpost.imageAlt")}
        />
      </div>
    </div>
  );
};
